import { useLoaderData } from "@remix-run/react";
import {
  termsAndConditionsLoader,
  termsAndConditionsMeta,
} from "framework/routes/index";
import { TermsAndConditionsPageContent } from "~/modules/informative-pages/pages";

export const loader = termsAndConditionsLoader;
export const meta = termsAndConditionsMeta;

export default function TermsConditions() {
  const data = useLoaderData<any>();

  return <TermsAndConditionsPageContent page={data} />;
}
